import { request } from '../request'
import { Subscription, Observable } from 'rxjs'
import gql from 'graphql-tag'
import { ApolloQueryResult } from 'apollo-client'
import { Apollo } from 'apollo-angular'
import { Injectable } from '@angular/core'
import { get } from 'lodash-es'

@Injectable({providedIn: 'root'})
export class SessionService {

  obs: Subscription;

  constructor(private apollo: Apollo) {}

  signedIn(): Promise<boolean> {
    return new Promise((resolve) => {
      this.obs = this.apollo.query({query: gql` { currentUser {id} } `, fetchPolicy: 'network-only'})
      .subscribe(({data}: ApolloQueryResult<{currentUser: {id: number}}>) => {
        if (data && data.currentUser) {
          resolve(true)
        } else {
          resolve(false)
        }
      })
    })
  }

  currentRole(): Promise<string | boolean> {
    return new Promise((resolve) => {
      this.obs = this.apollo.query({query: gql` { currentUser {id role} } `, fetchPolicy: 'network-only'})
      .subscribe(({data}: ApolloQueryResult<{currentUser: { id: number, role: string }}>) => {
        resolve(get(data, 'currentUser.role', false))
      })
    })
  }

  signedOut(): Promise<boolean> {
    return this.signedIn().then(signedIn => !signedIn)
  }

  signOut(): Promise<any> {
    return request.del('/api/users/sign_out.json')
  }

  checkSessionPeriodically(): Observable<boolean> {
    return new Observable(subscriber => {
      setInterval(() => {
        this.signedIn().then(signedIn => {
          subscriber.next(signedIn)
        })
      }, 300000) // 5 min
    })
  }

  ngOnDestroy(): void {
    this.obs.unsubscribe()
  }

}
